    <template>
      <div class="cms-youtube-cid">
        <el-dialog
          title="Insert a new channel"
          :visible="showChannelModal"
          width="500px"
          top="3vh"
          :modal="true"
          @close="handleClose()"
          @open="open"
        >
          <el-form label-position="top">
            <!-- Campaign Dropdown -->
            <el-form-item
                label="Campaign"
                :error="getValidationError('campaign_id')"
            >
              <el-select v-model="selectedCampaign" clearable placeholder="Select a campaign">
                <el-option
                    v-for="campaign in campaigns.data"
                    :key="campaign.campaign_id"
                    :label="campaign.name"
                    :value="campaign.campaign_id"
                />
              </el-select>
            </el-form-item>
            <!-- Track Dropdown -->
            <el-form-item label="Track">
              <el-select
                v-model="selectedTracks"
                clearable
                placeholder="Select tracks"
                :disabled="!selectedCampaign"
                multiple
              >
                <el-option
                  v-for="track in campaignTracks.data"
                  :key="track.id"
                  :label="track.title"
                  :value="track.id"
                />
              </el-select>
            </el-form-item>
            <!-- Channel ID Input -->
            <el-form-item
                label="Channel ID"
                :error="getValidationError('channel_id')"
            >
              <el-input type="text" clearable v-model="channel_id" />
            </el-form-item>
          </el-form>
          <div style="display: flex; gap: 10px">
            <el-form label-position="top" style="width: 48%; display: inline-block">
              <el-form-item
                  label="Channel Share(%)"
                  :error="getValidationError('channel_share')"
              >
                <el-input
                    type="number"
                    clearable
                    v-model="channel_share"
                    @input="updatePlatformShare"
                    :max="100"
                />
              </el-form-item>

            </el-form>
            <el-form label-position="top" style="width: 48%; display: inline-block">
              <el-form-item
                  label="Platform Share(%)"
              >
                <el-input type="number" clearable v-model="platform_share" disabled/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer">
            <el-button
              type="primary"
              size="mini"
              :loading="loading"
              @click="submit()"
            >
              Save
            </el-button>
          </div>
        </el-dialog>
      </div>
    </template>

    <script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default {
      data() {
        return {
          active: false,
          selectedCampaign: null,
          selectedTracks: [],
          channel_id: '',
          channel_share:'',
          platform_share:''
        }
      },
      computed: {
        ...mapState('revShareCampaigns', ['loading', 'campaigns', 'showChannelModal','campaignTracks','validation']),
      },
      watch: {
        selectedCampaign(newVal) {
          console.log(newVal);
          if (newVal) {
            this.fetchCampaignTracks(newVal) // Call method to fetch tracks
          }
        }
      },
      methods: {
        ...mapActions('revShareCampaigns', ['insertChannel','fetchCampaignTracks']),
        ...mapMutations('revShareCampaigns', ['setChannelModal','setValidation']),

        submit() {
          const payload = {
            campaign_id: this.selectedCampaign,
            track_ids: this.selectedTracks,
            channel_id: this.channel_id,
            channel_share:this.channel_share,
            platform_share:this.platform_share
          };
          this.insertChannel(payload)
          console.log(this.newCampaign)
        },

        open(){
          this.selectedCampaign = null
          this.selectedTrack = null
          this.channel_id = ''
          this.channel_share = ''
          this.platform_share = ''
        },
        handleClose() {
          this.setChannelModal(false);  // Close the modal
          this.setValidation({});         // Reset validation state
        },
        // Method to get the first error message or empty string
        getValidationError(field) {
          const errors = this.validation[field];
          return errors && errors.length > 0 ? errors[0] : ''; // Get the first error message
        },
        updatePlatformShare() {
          let labelShare = parseFloat(this.channel_share) || 0;

          if (labelShare > 100) {
            this.channel_share = 100; // Enforce max 100
            labelShare = 100;
          }

          this.platform_share = 100 - labelShare; // Auto-calculate platform share
        },
      },
      mounted() {
        console.log('Campaigns:', this.channels);
      }
    }
    </script>

    <style scoped lang="scss">

    </style>
